module.exports = __webpack_public_path__ + "img/nhom-hoc-lieu-3.1e8a13b3.svg";